import { render } from "./PermalinkList.vue?vue&type=template&id=75e70290&ts=true"
import script from "./PermalinkList.vue?vue&type=script&lang=ts"
export * from "./PermalinkList.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/damianowaga/Projects/mytechaccessories/wp-content/themes/mytechaccessories/addons/packages/catalog/assets/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__